import { styled } from '../ui/muiReexports';
import { shouldNotForwardProps } from '@/core/helpers';
export const Row = styled('div', shouldNotForwardProps('gap', 'alignItems', 'justifyContent', 'paddingBottom', 'paddingTop', 'fullWidth'))(({ gap, alignItems, justifyContent, paddingTop, paddingBottom, fullWidth }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: gap === 0 ? undefined : gap ? (typeof gap === 'number' ? `${gap / 4}rem` : gap) : '1.5rem',
    // TODO: to delete later
    // gap: gap === 0 ? undefined : gap ? (typeof gap === 'number' ? `${gap / 2}rem` : gap) : '1.5rem',
    alignItems,
    justifyContent,
    paddingTop,
    paddingBottom,
    ...(fullWidth && { width: '100%' }),
}));
